// extracted by mini-css-extract-plugin
export default {"c-loader":"Loader_c-loader__WZBQs","c-loader__fullpage-wrapper":"Loader_c-loader__fullpage-wrapper__SFiTK"};